<script>import SVG from "../elements/SVG.svelte";
import { createEventDispatcher } from "svelte";
export let data;
export let desc;
const dispatch = createEventDispatcher();
const dispatchChange = () => {
  dispatch("load", {
    number: data.number
  });
};
const gotoPage = (i) => {
  if (i >= 0 && i < data.totalPages && i !== data.number) {
    data = {
      ...data,
      number: i
    };
    dispatchChange();
  }
};
const gotoFirstPage = () => {
  gotoPage(0);
};
const gotoPrevPage = () => {
  gotoPage(data.number - 1);
};
const gotoNextPage = () => {
  gotoPage(data.number + 1);
};
const gotoLastPage = () => {
  gotoPage(data.totalPages - 1);
};
</script>

{#if data}
	<div
		class="flex flex-wrap justify-center sm:justify-between items-center
    py-5 md:py-6 space-y-2 sm:space-y-0"
	>
		{#if desc}
			<span>
				{desc}
			</span>
		{/if}
		<div class="pages">
			<span class="pages-item" on:click={() => gotoFirstPage()}>
				<SVG name="skip_previous" />
			</span>
			<span class="pages-item" on:click={() => gotoPrevPage()}>
				<SVG name="keyboard_arrow_left" />
			</span>

			{#if data.number === data.totalPages - 1 && data.totalPages > 2}
				<span class="pages-item" on:click={() => gotoPage(data.number - 2)}>
					{data.number - 1}
				</span>
			{/if}
			{#if data.number > 0}
				<span class="pages-item" on:click={() => gotoPage(data.number - 1)}>
					{data.number}
				</span>
			{/if}
			<span class="pages-item is-current-page" on:click={() => gotoPage(data.number)}>
				{data.number + 1}
			</span>
			{#if data.number < data.totalPages - 1}
				<span class="pages-item" on:click={() => gotoPage(data.number + 1)}>
					{data.number + 2}
				</span>
			{/if}
			{#if data.number === 0 && data.totalPages > 2}
				<span class="pages-item" on:click={() => gotoPage(data.number + 2)}>
					{data.number + 3}
				</span>
			{/if}

			<span class="pages-item" on:click={() => gotoNextPage()}>
				<SVG classNames="transform rotate-180" name="keyboard_arrow_left" />
			</span>
			<span class="pages-item" on:click={() => gotoLastPage()}>
				<SVG name="skip_next" />
			</span>
		</div>
	</div>
{/if}

<style>.pages{border-radius:.375rem;display:flex;-webkit-user-select:none;-moz-user-select:none;user-select:none;--tw-shadow:0 1px 3px 0 rgba(0,0,0,.1),0 1px 2px -1px rgba(0,0,0,.1);--tw-shadow-colored:0 1px 3px 0 var(--tw-shadow-color),0 1px 2px -1px var(--tw-shadow-color);box-shadow:0 0 transparent,0 0 transparent,0 1px 3px 0 rgba(0,0,0,.1),0 1px 2px -1px rgba(0,0,0,.1);box-shadow:var(--tw-ring-offset-shadow,0 0 transparent),var(--tw-ring-shadow,0 0 transparent),var(--tw-shadow)}.pages,.pages>.pages-item{align-items:center;justify-content:center}.pages>.pages-item{border-bottom-width:1px;border-right-width:1px;border-top-width:1px;cursor:pointer;display:inline-flex;height:2rem;width:2rem;--tw-border-opacity:1;border-color:#f7f7f7;border-color:rgba(247,247,247,var(--tw-border-opacity,1));font-size:.875rem;font-weight:700;line-height:1.25rem;padding:.5rem}.pages>.pages-item:hover{--tw-bg-opacity:1;background-color:#f7f7f7;background-color:rgba(247,247,247,var(--tw-bg-opacity,1));--tw-shadow:0 10px 15px -3px rgba(0,0,0,.1),0 4px 6px -4px rgba(0,0,0,.1);--tw-shadow-colored:0 10px 15px -3px var(--tw-shadow-color),0 4px 6px -4px var(--tw-shadow-color);box-shadow:0 0 transparent,0 0 transparent,0 10px 15px -3px rgba(0,0,0,.1),0 4px 6px -4px rgba(0,0,0,.1);box-shadow:var(--tw-ring-offset-shadow,0 0 transparent),var(--tw-ring-shadow,0 0 transparent),var(--tw-shadow)}@media (min-width:768px){.pages>.pages-item{height:3rem;width:3rem}}.pages>.pages-item:first-child{border-bottom-left-radius:.375rem;border-left-width:1px;border-top-left-radius:.375rem}.pages>.pages-item:last-child{border-bottom-right-radius:.375rem;border-top-right-radius:.375rem}.pages>.pages-item.is-current-page{background-color:var(--color-primary);border-color:var(--color-primary);--tw-text-opacity:1;color:#fff;color:rgba(255,255,255,var(--tw-text-opacity,1))}</style>
